module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/iga-d637e5a4e504570e4a79feee8bd866f3.jpg";